import { Link } from '@tanstack/react-router';
import { Check, ChevronRight, CircleDashed, Minus } from 'lucide-react';
import type { GuestItem } from './objectGuestItems';

const TONE_ICON = {
  ok: <Check size={16} strokeWidth={2.5} className="text-sage" aria-hidden />,
  open: <CircleDashed size={16} strokeWidth={2} className="text-ink-soft" aria-hidden />,
  neutral: <Minus size={16} strokeWidth={2} className="text-ink-faint" aria-hidden />,
};

/**
 * „Für Gäste": was Gäste dieses Objekts sehen und bekommen. Jede Zeile führt in ihren Bereich;
 * gepflegt wird dort, hier steht nur der Stand.
 */
export function ObjectGuestReadiness({ groupId, items }: { groupId: string; items: GuestItem[] }) {
  return (
    <section
      aria-labelledby="object-guest-readiness"
      className="border-line bg-card shadow-card rounded-lg border"
    >
      <div className="border-line/60 border-b px-5 py-4">
        <h2 id="object-guest-readiness" className="text-ink font-serif text-lg">
          Für Gäste
        </h2>
        <p className="text-ink-soft mt-0.5 text-sm">Was Gäste dieses Objekts sehen und bekommen.</p>
      </div>
      <ul className="divide-line/60 divide-y">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={item.to}
              params={{ id: groupId }}
              className="hover:bg-card-alt/50 focus-visible:ring-sage flex min-h-14 items-center gap-3 px-5 py-2.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
            >
              <span className="min-w-0 flex-1">
                <span className="text-ink block text-sm font-semibold">{item.label}</span>
                <span className="text-ink-soft block text-xs">{item.detail}</span>
              </span>
              {item.action ? (
                <span className="text-sage text-xs font-semibold">{item.action}</span>
              ) : (
                TONE_ICON[item.tone]
              )}
              <ChevronRight size={16} className="text-ink-faint shrink-0" aria-hidden />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
